<template>
  <v-main v-touch="{left: next, right: previous}">
    <div v-if="loaded">
      <v-btn color="#7400b8"
             dark
             fab
             small
             fixed
             bottom
             right
             @click="next"
             v-if="current < 13">
        <v-icon>
          mdi-chevron-right
        </v-icon>
      </v-btn>
      <v-btn color="#7400b8"
             dark
             fab
             small
             fixed
             bottom
             left
             @click="previous"
             v-if="current > 0">
        <v-icon>
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <MovieShowcase :title="this.$route.params['year']"
                     subtitle="Tu año en cine"
                     :src="getWelcome"
                     v-if="current === 0"/>
      <Numbers :count="history.length" :total="stats.total" :minutes="stats.minutes" v-if="current === 1" :tc_records="stats.tc_records"/>
      <MovieShowcase :title="history.at(0).original_title"
                     :subtitle="'Empezaste tu viaje con...'"
                     :poster="history.at(0).poster"
                     :background_text="true"
                     :src="'https://image.tmdb.org/t/p/original/' + history.at(0).backdrop"
                     v-if="current === 2"
      />
      <TopLanguagesWrapper
          :headline="'Un viaje que te llevaría por ' + Object.keys(stats.top_languages).length + ' idiomas'"
          :stats="stats"
          v-if="current === 3"
      />
      <GenresWrapper :headline="'Y por ' + Object.keys(stats.top_genres).length + ' géneros'"
                     :stats="stats"
                     v-if="current === 4"/>
      <CountryChart :countries="stats.countries" v-if="current === 5"/>
      <Platforms :stats="stats" :headline="'Y ' + Object.keys(stats.platforms).length + ' plataformas'"
                 v-if="current === 6"/>
      <MonthlyViewWrapper headline="Para terminar viéndose así"
                          :stats="stats" v-if="current === 7"/>
      <MovieShowcase :title="history.at(-1).original_title"
                     :subtitle="'Con un cierre a lo grande con...'"
                     :poster="history.at(-1).poster"
                     :background_text="true"
                     :src="'https://image.tmdb.org/t/p/original/' + history.at(-1).backdrop"
                     v-if="current === 8"
      />
      <TopPeople :headline="'Fue un ' + this.$route.params['year'] + ' lleno de estrellas'" :people="stats.top_stars" v-if="current === 9"/>
      <TopPeople headline="Y de grandes directores" :people="stats.top_directors" v-if="current === 10"/>
      <Playlist v-if="current === 11"/>
      <HistoryWrapper :records="history" v-if="current === 12"/>
      <ShareLink v-if="current === 13"/>
    </div>
    <div v-else>
      <v-row align="center" justify="center" class="fill-height">
        <v-col align="center">
          <v-progress-circular indeterminate color="#7400b8"/>
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>

<script>
import Numbers from "@/components/Numbers";
import MovieShowcase from "@/components/MovieShowcase";
import TopPeople from "@/components/TopPeople";
import CountryChart from "@/components/wrappers/CountryChart";
import axios from "axios";
import TopLanguagesWrapper from "@/components/wrappers/TopLanguagesWrapper";
import HistoryWrapper from "@/components/wrappers/HistoryWrapper";
import GenresWrapper from "@/components/wrappers/GenresWrapper";
import MonthlyViewWrapper from "@/components/wrappers/MonthlyViewWrapper";
import ShareLink from "@/components/ShareLink";
import {year_welcome} from "@/utils/data";
import Playlist from "@/components/Playlist";
import Platforms from "@/components/wrappers/Platforms";

const BASE_URL = process.env.VUE_APP_API_URL


export default {
  name: 'App',
  components: {
    Platforms,
    Playlist,
    ShareLink,
    MonthlyViewWrapper,
    GenresWrapper,
    HistoryWrapper,
    TopLanguagesWrapper,
    CountryChart,
    TopPeople,
    MovieShowcase,
    Numbers,
  },
  methods: {
    next() {
      if (!this.loaded) {
        return
      }
      if (this.current < 13)
        this.current = this.current + 1;
    },
    previous() {
      if (!this.loaded) {
        return
      }
      if (this.current > 0)
        this.current -= 1;
    },
    loadStats() {
      axios(
          {
            method: 'get',
            url: BASE_URL + 'stats/report/',
            params: {
              page_size: 0,
              token: this.$route.params['token'],
              user_id: this.$route.params['user_id'],
              year: this.$route.params['year'],
            }
          }
      ).then(res => {
        this.stats = res.data;
        this.topStarMovie = this.getRandomMoviePeople(this.stats.top_stars)
        this.topDirectorMovie = this.getRandomMoviePeople(this.stats.top_directors)
        this.history = this.stats.history
        this.loaded = true
      }).catch(() => {
        console.log("ERROR: Loading Stats")
        this.$router.push('/error');
      })
    },
    randomSelection(array) {
      return array[~~(Math.random() * array.length)];
    },
    getRandomMoviePeople(top_people) {
      let people = this.randomSelection(top_people)
      let movie = this.randomSelection(people.movies)
      movie['name'] = people.name
      return movie
    }
  },
  data: () => ({
    current: 0,
    history: [],
    stats: {
      history: [{original_title: '', poster: ''}],
      top_genres: {},
      top_languages: {},
      countries: [],
      count: 0,
      total: 1,
    },
    top_actor: null,
    topStarMovie: {tmdb_id: 0, name: '', original_title: '', poster: '', profile_path: ''},
    topDirectorMovie: {tmdb_id: 0, name: '', original_title: '', poster: '', profile_path: ''},
    loaded: false,
  }),
  computed: {
    getWelcome() {
      let year = this.$route.params['year'];
      if (year in year_welcome) {
        return year_welcome[this.$route.params['year']];
      } else {
        return 'https://image.tmdb.org/t/p/original/lzWHmYdfeFiMIY4JaMmtR7GEli3.jpg';
      }
    }
  },
  created() {
    this.loadStats();
  },
  beforeCreate() {
    let current_year = new Date().getFullYear();
    if (this.$route.params['year'] > current_year) {
      this.$router.push('/error');
    }
  }
};
</script>
